// 认证相关 API

// EdgeOne Pages 前后端同域名，使用相对路径
const API_BASE = import.meta.env.VITE_API_BASE || '';

// 构建完整 API URL
const getApiUrl = (path) => {
  return `${API_BASE}${path}`;
};

// 登录
export const login = async (username, password) => {
  try {
    const response = await fetch(getApiUrl('/api/login'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
    }
    
    return response.json();
  } catch (error) {
    console.error('Login API error:', error);
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      return { 
        success: false, 
        error: '网络错误：无法连接到服务器，请检查网络连接' 
      };
    }
    return { success: false, error: error.message };
  }
};

// 验证 Token
export const verifyToken = async (token) => {
  try {
    const response = await fetch(getApiUrl('/api/verify'), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    
    return response.json();
  } catch (error) {
    console.error('Verify API error:', error);
    return { valid: false, error: error.message };
  }
};

// 获取临时密钥
export const getSTS = async (token) => {
  try {
    const response = await fetch(getApiUrl('/api/sts'), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    });
    
    return response.json();
  } catch (error) {
    console.error('STS API error:', error);
    return { success: false, error: error.message };
  }
};

// 获取前端配置（CDN域名等）
export const getConfig = async () => {
  try {
    const response = await fetch(getApiUrl('/api/config'));
    return response.json();
  } catch (error) {
    console.error('Config API error:', error);
    return { success: false, error: error.message };
  }
};
